document.addEventListener("DOMContentLoaded", function() {
  var video = document.querySelectorAll('video[data-desktop-url][data-mobile-url]:not(.lazy)');

  var lazyVideos = [].slice.call(document.querySelectorAll("video[data-desktop-url][data-mobile-url].lazy"));

  //add source to video tag
  function addSourceToVideo(element, src) {
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      element.appendChild(source)
  }

  // determine screen size and select mobile or desktop vid
  function whichSizeVideo(element, src) {
    var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
    if (windowWidth > 960 ) {
      addSourceToVideo( element, src.dataset.desktopUrl);
    } else {
      addSourceToVideo(element, src.dataset.mobileUrl);
    }
  }

  //init only if page has videos
  function videoSize() {
    if (video !== undefined) {
    video.forEach(function(element, index) {
        whichSizeVideo(
          element, //element
          element  //src locations
        );
      });
    }
  }

  videoSize();

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          whichSizeVideo(
            video.target, //element
            video.target  //src locations
          );

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
